// eslint-disable-next-line internal-rules/no-restricted-async-data-context-imports -- to be removed once this file is deleted by an in-progress migration
import { createPrefetchableAsyncDataContext } from '#src/app/shared/contexts/asyncData';

import { getMembershipBottomBannerData } from './api';

/** @knip-ignore */
export const {
	Context: MembershipBottomBannerDataContext,
	Provider: MembershipBottomBannerDataContextProvider,
	useContext: useMembershipBottomBannerData,
	useAsyncData: useMembershipBottomBannerDataFromApi,
	prefetchAsyncData: prefetchMembershipBottomBannerDataFromApi,
} = createPrefetchableAsyncDataContext({
	name: 'MembershipBottomBannerDataContext',
	dataProperty: 'data',
	getData: getMembershipBottomBannerData,
	getUniqueId: ({ countryCode }) => countryCode,
	hookDeps: ({ countryCode }) => [countryCode],
});
